import { render, staticRenderFns } from "./ListMenuItemMiniWithoutProfile.vue?vue&type=template&id=7b45c9ee&scoped=true"
import script from "./ListMenuItemMiniWithoutProfile.vue?vue&type=script&lang=js"
export * from "./ListMenuItemMiniWithoutProfile.vue?vue&type=script&lang=js"
import style0 from "./ListMenuItemMiniWithoutProfile.vue?vue&type=style&index=0&id=7b45c9ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45c9ee",
  null
  
)

export default component.exports